import { render, staticRenderFns } from "./report-income.vue?vue&type=template&id=28fb2f94&"
import script from "./report-income.vue?vue&type=script&lang=js&"
export * from "./report-income.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports